module.exports = __webpack_public_path__ + "static/media/icon2.05f5a795.png";